export default __webpack_public_path__ + "static/media/nagarjuna.62a0623a.png";